export default __webpack_public_path__ + "static/media/imToken.a3fab637.svg";